// AUTO-GENERATED by scripts/generate-performance-indexes.mjs. Do not edit manually.
export const blogIndex = [
  {
    "title": "Blueberry Funded Payouts Explained: Rules, Timing & What Traders Should Know",
    "excerpt": "A current look at Blueberry Funded payout rules, including reward cycles, minimum trading days, minimum withdrawal amounts, KYC, profit split, and the funded-stage rules traders should check before requesting a payout.",
    "author": "PropViper",
    "date": "2026-08-21",
    "readTime": "9 min read",
    "image": "/blog/thumbs/podium.jpg",
    "category": "Prop Firm Reviews",
    "categorySlug": "reviews",
    "conversion": {
      "relatedFirms": [
        "blueberryfunded"
      ],
      "primaryPath": "/reviews/blueberryfunded",
      "primaryLabel": "Read our Blueberry Funded review",
      "secondaryPath": "/best-prop-firms?tab=payout",
      "secondaryLabel": "Compare payout schedules"
    },
    "slug": "blueberry-funded-payouts-explained",
    "sourceFile": "blueberry-funded-payouts-explained.mdx"
  },
  {
    "title": "Prop Firm Scalping Rules Explained: What Traders Need to Check",
    "excerpt": "Scalping is not treated the same way by every prop firm. Learn the rule details to check before buying a challenge, including minimum hold times, excessive scalping, news trading, latency rules, and payout reviews.",
    "author": "PropViper",
    "date": "2026-08-18",
    "readTime": "9 min read",
    "image": "/blog/thumbs/forex-tools-2025.webp",
    "category": "Guides",
    "categorySlug": "guides",
    "conversion": {
      "primaryPath": "/best-prop-firms",
      "primaryLabel": "Compare prop firms before you buy",
      "secondaryPath": "/reviews",
      "secondaryLabel": "Check current firm reviews"
    },
    "slug": "prop-firm-scalping-rules-explained",
    "sourceFile": "prop-firm-scalping-rules-explained.mdx"
  },
  {
    "title": "Prop Firm Payout Rules Explained: What Can Delay or Deny a Payout?",
    "excerpt": "A practical guide to prop firm payout rules, including eligibility windows, minimum trading days, consistency checks, prohibited strategies, KYC, and why profitable traders can still have payouts delayed or denied.",
    "author": "PropViper",
    "date": "2026-08-14",
    "readTime": "10 min read",
    "image": "/blog/thumbs/podium.jpg",
    "category": "Guides",
    "categorySlug": "guides",
    "conversion": {
      "primaryPath": "/best-prop-firms?tab=payout",
      "primaryLabel": "Compare prop firm payout schedules",
      "secondaryPath": "/reviews",
      "secondaryLabel": "Read current prop firm reviews"
    },
    "slug": "prop-firm-payout-rules-explained",
    "sourceFile": "prop-firm-payout-rules-explained.mdx"
  },
  {
    "title": "Prop Firm Drawdown Rules Explained: Daily, Maximum & Trailing Drawdown",
    "excerpt": "Understand how prop firm drawdown really works, including daily loss limits, maximum drawdown, static vs trailing rules, and the calculations that catch traders out.",
    "author": "PropViper",
    "date": "2026-08-11",
    "readTime": "9 min read",
    "image": "/blog/thumbs/risk-management-strategies.webp",
    "category": "Guides",
    "categorySlug": "guides",
    "conversion": {
      "primaryPath": "/best-prop-firms?tab=drawdown&preset=risk",
      "primaryLabel": "Compare prop firm drawdown rules",
      "secondaryPath": "/tools/lot-calculator",
      "secondaryLabel": "Calculate a safer lot size"
    },
    "slug": "prop-firm-drawdown-rules-explained",
    "sourceFile": "prop-firm-drawdown-rules-explained.mdx"
  },
  {
    "title": "Prop Firm Red Flags: 12 Warning Signs to Check Before You Pay",
    "excerpt": "Learn the practical warning signs to check before buying a prop firm challenge, from unclear drawdown rules and payout restrictions to weak terms, changing conditions and misleading marketing.",
    "date": "2026-08-08",
    "author": "PropViper",
    "readTime": "10 min read",
    "category": "Guides",
    "categorySlug": "guides",
    "image": "/blog/thumbs/prop-firm-red-flags.png",
    "conversion": {
      "primaryPath": "/best-prop-firms",
      "primaryLabel": "Compare active prop firms",
      "secondaryPath": "/reviews",
      "secondaryLabel": "Read PropViper reviews"
    },
    "slug": "prop-firm-red-flags",
    "sourceFile": "prop-firm-red-flags.mdx"
  },
  {
    "title": "Prop Firm vs Trading Your Own Money: Which Is Better in 2026?",
    "excerpt": "Compare prop firm trading with using your own capital. See the real differences in risk, flexibility, payouts, rules, scaling and when each route makes more sense.",
    "author": "PropViper",
    "date": "2026-08-08",
    "readTime": "11 min read",
    "image": "/blog/thumbs/prop-firm-vs-independently.webp",
    "category": "Guides",
    "categorySlug": "guides",
    "conversion": {
      "primaryPath": "/best-prop-firms",
      "primaryLabel": "Compare active prop firms",
      "secondaryPath": "/tools/lot-calculator",
      "secondaryLabel": "Plan your risk per trade"
    },
    "slug": "prop-firm-vs-trading-independently",
    "sourceFile": "prop-firm-vs-trading-independently.mdx"
  },
  {
    "title": "10 Forex Trading Tools That Will Improve Your Trading Strategy",
    "excerpt": "Discover the top 10 forex trading tools—used by real traders and experts—to optimize your forex trading strategy and boost your results.",
    "author": "PropViper",
    "date": "2025-07-05",
    "readTime": "8 min read",
    "image": "/blog/thumbs/forex-tools-2025.webp",
    "category": "Trading Tips",
    "categorySlug": "trading-tips",
    "slug": "forex-trading-tools-2025",
    "sourceFile": "forex-trading-tools-2025.mdx"
  },
  {
    "title": "3 Psychological Techniques to Overcome Trading Fear and Boost Performance",
    "excerpt": "Practical mindset strategies to help traders conquer fear and improve results during prop firm challenges.",
    "author": "PropViper",
    "date": "2025-07-01",
    "readTime": "7 min read",
    "image": "/blog/thumbs/trading-fear-tips.webp",
    "category": "Trading Tips",
    "categorySlug": "trading-tips",
    "slug": "3-psychological-techniques-overcome-trading-fear-boost-performance",
    "sourceFile": "3-psychological-techniques-overcome-trading-fear-boost-performance.mdx"
  },
  {
    "title": "Best Risk Management Strategies for Prop Firm Challenges",
    "excerpt": "Risk management is what separates funded traders from blown accounts. Here are the risk rules you need to follow to pass any prop firm challenge.",
    "author": "Khusairy Chen",
    "date": "2025-06-26",
    "readTime": "7 min read",
    "image": "/blog/thumbs/risk-management-strategies.webp",
    "category": "Trading Tips",
    "categorySlug": "trading-tips",
    "slug": "best-risk-management-strategies-prop-firm",
    "sourceFile": "best-risk-management-strategies-prop-firm.mdx"
  },
  {
    "title": "Ukraine-Russia Ceasefire Talks Stall Amid Drone Strikes: What Traders Should Know",
    "excerpt": "The latest round of Ukraine-Russia peace talks ended without a ceasefire. Instead, renewed drone attacks and prisoner exchanges dominated the headlines. Here’s what traders need to know.",
    "author": "PropViper",
    "date": "2025-06-03",
    "readTime": "6 min read",
    "image": "/blog/thumbs/ukraine-russia-ceasefire-drone.webp",
    "category": "News & Updates",
    "categorySlug": "news",
    "slug": "ukraine-russia-ceasefire-talks-stall",
    "sourceFile": "ukraine-russia-ceasefire-talks-stall.mdx"
  },
  {
    "title": "Elon Musk Leaves DC: What It Means for Traders",
    "excerpt": "Elon Musk’s Oval Office send-off was more than a political spectacle—it’s a lesson in billionaire power, market sentiment, and how narrative shapes trading opportunity—including in crypto.",
    "author": "PropViper",
    "date": "2025-06-01",
    "readTime": "10 min read",
    "image": "/blog/thumbs/elon-dc-oval-office.webp",
    "category": "News & Updates",
    "categorySlug": "news",
    "slug": "elon-musk-leaves-dc-what-it-means-for-traders",
    "sourceFile": "elon-musk-leaves-dc-what-it-means-for-traders.mdx"
  },
  {
    "title": "Are Your Prop Firm Profits Taxable? What Every Trader Needs to Know (Global Guide)",
    "excerpt": "Learn the essential tax rules for prop firm traders worldwide. This guide explains what income is taxable, how to report payouts, and common mistakes to avoid—no matter where you live.",
    "author": "PropViper",
    "date": "2025-05-31",
    "readTime": "8 min read",
    "image": "/blog/thumbs/prop-firm-tax-guide.webp",
    "category": "Guides",
    "categorySlug": "guides",
    "slug": "are-your-prop-firm-profits-taxable",
    "sourceFile": "are-your-prop-firm-profits-taxable.mdx"
  },
  {
    "title": "How to Make $1 Million by Prop Trading Before 60",
    "excerpt": "Discover a realistic, step-by-step path to reaching $1 million through prop trading, starting with a $10k challenge account and scaling up—no get-rich-quick hype.",
    "author": "PropViper",
    "date": "2025-05-18",
    "readTime": "8 min read",
    "image": "/blog/thumbs/make-1-million-before-60.webp",
    "category": "Guides",
    "categorySlug": "guides",
    "slug": "make-1-million-prop-trading-before-60",
    "sourceFile": "make-1-million-prop-trading-before-60.mdx"
  },
  {
    "title": "Should You Start with a $10K or $100K Prop Account?",
    "slug": "10k-vs-100k-prop-account",
    "excerpt": "Deciding between a $10K or $100K prop firm account? This guide compares cost, risk, payout potential, psychology, and trader fit so you can choose wisely.",
    "author": "PropViper",
    "date": "2025-05-12",
    "readTime": "8 min read",
    "image": "/blog/thumbs/10k-vs-100k-prop-account.webp",
    "category": "Guides",
    "categorySlug": "guides",
    "tags": [
      "prop firms",
      "trading accounts",
      "risk management",
      "trading psychology"
    ],
    "sourceFile": "10k-vs-100k-prop-account.mdx"
  },
  {
    "title": "What is a Prop Trading Firm? A Complete Guide for 2025",
    "slug": "what-is-a-prop-trading-firm",
    "excerpt": "Discover how proprietary trading firms work, how to get funded, and which prop firms are best for you. A must-read for anyone exploring funded trading.",
    "author": "PropViper",
    "date": "2025-05-11",
    "readTime": "8 min read",
    "image": "/blog/thumbs/prop-trading-firm-guide.webp",
    "category": "Guides",
    "categorySlug": "guides",
    "sourceFile": "what-is-a-prop-trading-firm.mdx"
  },
  {
    "title": "What Is Profit Consistency? The Key Metric Prop Firms Look For",
    "excerpt": "Learn why profit consistency is the most important metric prop firms evaluate and how to improve your trading consistency to get funded.",
    "author": "PropViper",
    "date": "2025-05-08",
    "readTime": "6 min read",
    "image": "https://images.unsplash.com/photo-1535320903710-d993d3d77d29?auto=format&fit=crop&q=80&w=1000",
    "category": "Trading Tips",
    "categorySlug": "trading-tips",
    "slug": "profit-consistency",
    "sourceFile": "profit-consistency.mdx"
  },
  {
    "title": "Big Update for Malaysian Traders from WeMasterTrade",
    "slug": "wmt-malaysia-may-2025-update",
    "excerpt": "Exclusive updates for Malaysian traders: local bank transfers, giveaway, profit consistency boost, and more.",
    "author": "PropViper",
    "date": "2025-05-07",
    "readTime": "3 min read",
    "image": "/blog/thumbs/wmt-update.webp",
    "category": "Announcements",
    "categorySlug": "announcements",
    "sourceFile": "wmt-malaysia-may-2025-update.mdx"
  },
  {
    "title": "FXIFY Discount: Save Up to 30% on All Challenges",
    "excerpt": "Save up to 30% on all FXIFY challenges. Limited time offer - don't miss out!",
    "author": "James Rodriguez",
    "date": "2025-04-24",
    "readTime": "5 min read",
    "image": "/blog/thumbs/20-percent.png",
    "category": "News & Updates",
    "categorySlug": "news",
    "slug": "fxify-discount-code",
    "sourceFile": "fxify-discount-code.mdx"
  },
  {
    "title": "7 Daily Habits of Funded Prop Traders (That Actually Work)",
    "excerpt": "Learn 7 proven habits that help funded traders succeed in prop firm challenges & live accounts.",
    "author": "PropViper",
    "date": "2025-04-15",
    "readTime": "5 min read",
    "image": "https://images.unsplash.com/photo-1553877522-43269d4ea984?auto=format&fit=crop&q=80&w=1000",
    "category": "Trading Tips",
    "categorySlug": "trading-tips",
    "slug": "habits-of-successful-prop-traders",
    "sourceFile": "habits-of-successful-prop-traders.mdx"
  },
  {
    "title": "SSC Prop Firm Shutdown: What Traders Can Learn from Summit Strike Capital's Collapse",
    "slug": "ssc-prop-firm-shutdown",
    "excerpt": "Malaysia-based prop firm SSC shut down in April 2025 after MetaQuotes revoked their MT5 access. Here's what happened — and lessons for traders worldwide.",
    "author": "PropViper Editorial Team",
    "date": "2025-04-13",
    "readTime": "6 min read",
    "image": "/blog/thumbs/ssc-shutdown.png",
    "category": "News & Updates",
    "categorySlug": "news",
    "sourceFile": "ssc-prop-firm-shutdown.mdx"
  },
  {
    "title": "Forex Market Outlook April 2025",
    "slug": "forex-market-outlook-april-2025",
    "excerpt": "Key forex events and analysis for April 2025 that traders need to watch.",
    "author": "PropViper Team",
    "date": "2025-04-12",
    "readTime": "7 min read",
    "image": "/blog/thumbs/forex-market-outlook-april-2025.png",
    "category": "News & Updates",
    "categorySlug": "news",
    "sourceFile": "forex-market-outlook-april-2025.mdx"
  },
  {
    "title": "What Peter Brandt Can Teach You About Passing Prop Firm Challenges",
    "excerpt": "Legendary trader Peter Brandt has survived decades in the markets. Here’s what his mindset can teach you about passing prop firm evaluations — and staying funded.",
    "author": "Khusairy Chen",
    "date": "2025-04-10",
    "readTime": "7 min read",
    "image": "/blog/thumbs/peter-brandt-artwork.webp",
    "category": "Challenges & Strategy",
    "categorySlug": "challenges",
    "slug": "peter-brandt-prop-firm-mindset",
    "sourceFile": "peter-brandt-prop-firm-mindset.mdx"
  },
  {
    "title": "Top 5 Prop Trading Firms to Watch in 2025",
    "slug": "top-5-prop-trading-firms-2025",
    "excerpt": "Discover the top 5 prop trading firms that every serious trader should consider in 2025 — complete with pros, cons, and a comparison table.",
    "author": "Khusairy Chen",
    "date": "2025-04-09",
    "readTime": "8 min read",
    "image": "/blog/thumbs/podium.jpg",
    "category": "Prop Firm Reviews",
    "categorySlug": "reviews",
    "sourceFile": "top-5-prop-trading-firms-2025.mdx"
  },
  {
    "title": "FXIFY Review 2025: Is This the Best Prop Firm for Scalpers?",
    "excerpt": "A deep dive into FXIFY’s features, rules, and real-world performance to see if it’s the go-to prop firm for scalpers in 2025.",
    "author": "James Rodriguez",
    "date": "2025-04-02",
    "readTime": "7 min read",
    "image": "/blog/thumbs/butterfly.jpg",
    "category": "Prop Firm Reviews",
    "categorySlug": "reviews",
    "slug": "fxify-review-scalpers",
    "sourceFile": "fxify-review-scalpers.mdx"
  },
  {
    "title": "E8 vs Alpha Capital: Which Prop Firm is Better?",
    "excerpt": "A side-by-side breakdown of E8 and Alpha Capital to help you decide which prop firm suits your trading style.",
    "author": "George Chong",
    "date": "2025-04-01",
    "readTime": "5 min read",
    "image": "/blog/thumbs/female-wrestler.webp",
    "category": "Prop Firm Reviews",
    "categorySlug": "reviews",
    "slug": "e8-vs-alpha-capital",
    "sourceFile": "e8-vs-alpha-capital.mdx"
  },
  {
    "title": "Alpha Capital Group's Free Monthly Trading Competition: Your Chance to Win Big!",
    "excerpt": "Join Alpha Capital's free monthly trading competition for a chance to win funded accounts worth up to $100K. No entry fees, real trading conditions, and valuable prizes await!",
    "author": "Sarah Chen",
    "date": "2025-03-28",
    "readTime": "8 min read",
    "image": "https://images.unsplash.com/photo-1642543492481-44e81e3914a7?auto=format&fit=crop&q=80&w=1000",
    "category": "News & Updates",
    "categorySlug": "news",
    "slug": "alpha-capital-free-trading-competition",
    "sourceFile": "alpha-capital-free-trading-competition.mdx"
  },
  {
    "title": "5 Mistakes That Cause Traders to Fail Prop Firm Challenges",
    "excerpt": "Avoid these common pitfalls that lead to evaluation failures and learn how to increase your chances of getting funded.",
    "author": "James Rodriguez",
    "date": "2025-03-21",
    "readTime": "6 min read",
    "image": "https://images.unsplash.com/photo-1525847185619-02460ddde30d?auto=format&fit=crop&q=80&w=1000",
    "category": "Challenges & Strategy",
    "categorySlug": "challenges",
    "slug": "5-mistakes-that-cause-traders-to-fail-prop-firm-challenges",
    "sourceFile": "5-mistakes-that-cause-traders-to-fail-prop-firm-challenges.mdx"
  },
  {
    "title": "City Traders Imperium vs The Trading Pit – Which Prop Firm Offers the Best Funding?",
    "excerpt": "An in-depth comparison between CTI and TTP, focusing on evaluation difficulty, payout structure, and trader benefits.",
    "author": "Michael Thompson",
    "date": "2025-03-18",
    "readTime": "8 min read",
    "image": "https://images.unsplash.com/photo-1590283603385-17ffb3a7f29f?auto=format&fit=crop&q=80&w=1000",
    "category": "Prop Firm Reviews",
    "categorySlug": "reviews",
    "slug": "cti-vs-ttp-comparison",
    "sourceFile": "cti-vs-ttp-comparison.mdx"
  },
  {
    "title": "How to Pass a Prop Firm Challenge Without Blowing Your Account",
    "excerpt": "Learn proven strategies and risk management techniques to successfully pass prop firm evaluations and secure your funded account.",
    "author": "Sarah Chen",
    "date": "2025-03-16",
    "readTime": "10 min read",
    "image": "https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?auto=format&fit=crop&q=80&w=1000",
    "category": "Trading Tips",
    "categorySlug": "trading-tips",
    "slug": "how-to-pass-prop-firm-challenge-guide",
    "sourceFile": "how-to-pass-prop-firm-challenge-guide.mdx"
  },
  {
    "title": "How to Stay Motivated After Failing a Prop Firm Challenge",
    "excerpt": "Many traders fail their first few challenges. This post will provide strategies to bounce back stronger and keep pushing forward.",
    "author": "Sarah Chen",
    "date": "2025-03-11",
    "readTime": "9 min read",
    "image": "https://images.unsplash.com/photo-1502085671122-2d218cd434e6?auto=format&fit=crop&q=80&w=1000",
    "category": "Trading Tips",
    "categorySlug": "trading-tips",
    "slug": "staying-motivated-after-failure",
    "sourceFile": "staying-motivated-after-failure.mdx"
  },
  {
    "title": "The Truth About Full-Time Prop Trading: What No One Tells You",
    "excerpt": "Prop trading isn't always about financial freedom. This post explores the real challenges traders face beyond the dream.",
    "author": "David Miller",
    "date": "2025-03-08",
    "readTime": "11 min read",
    "image": "https://images.unsplash.com/photo-1579226905180-636b76d96082?auto=format&fit=crop&q=80&w=1000",
    "category": "Trading Tips",
    "categorySlug": "trading-tips",
    "slug": "truth-about-prop-trading",
    "sourceFile": "truth-about-prop-trading.mdx"
  },
  {
    "title": "10 Prop Trading Myths You Need to Stop Believing",
    "excerpt": "Debunk common misconceptions about prop firms, trading psychology, and what it really takes to succeed.",
    "author": "Emma Wilson",
    "date": "2025-03-06",
    "readTime": "10 min read",
    "image": "https://images.unsplash.com/photo-1526304640581-d334cdbbf45e?auto=format&fit=crop&q=80&w=1000",
    "category": "Trading Tips",
    "categorySlug": "trading-tips",
    "slug": "prop-trading-myths",
    "sourceFile": "prop-trading-myths.mdx"
  },
  {
    "title": "How to Build a Bulletproof Trading Mindset",
    "excerpt": "A trader's biggest enemy is often their own emotions. This post will guide them on developing mental toughness and discipline.",
    "author": "Sarah Chen",
    "date": "2025-03-03",
    "readTime": "9 min read",
    "image": "https://images.unsplash.com/photo-1502085671122-2d218cd434e6?auto=format&fit=crop&q=80&w=1000",
    "category": "Trading Tips",
    "categorySlug": "trading-tips",
    "slug": "bulletproof-trading-mindset",
    "sourceFile": "bulletproof-trading-mindset.mdx"
  }
] as const;

export default blogIndex;
